import { combineReducers } from 'redux';

import auth from './auth';
import devices from './devices';
import facilities from './facilities';
import flow from './flow';
import team from './team';
import users from './users';

const rootReducer = combineReducers({
  auth,
  flow,
  users,
  devices,
  facilities,
  team,
});

export default rootReducer;
